import { colors } from 'fitify-ui'
import { StyledSection } from 'fitify-ui-landing/src/components/Section/Section.Styled'
import { TextStyles } from 'fitify-ui-landing/src/components/Text'
import { phone } from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

import { StyledContainer } from '@/components/Container/Container.Styled'

export const StyledFeaturesSection = styled(StyledSection)`
  &:not(:first-child) {
    padding: 120px 0;
    background: ${colors.RoyalBlue100};

    ${phone(css`
      padding: 60px 0;
    `)};
  }
`

export const StyledFeaturesContainer = styled(StyledContainer)`
  padding: 0 104px;

  ${phone(css`
    padding: 0 24px;
  `)}
`

export const StyledTextWrapper = styled.div`
  ${TextStyles} {
    font-size: 48px;
    text-align: center;

    ${phone(css`
      font-size: 40px;
    `)}
  }
`
